export type AnalysisQuartileTarget =
	| 'quartile1'
	| 'quartile2'
	| 'quartile3'
	| 'quartile4'
	| 'quartileTotal';

export type AnalysisQuartileOption = {
	text: string;
	label: string;
	value: AnalysisQuartileTarget;
};

export const AnalysisQuartileOptions = (): {
	[key in AnalysisQuartileTarget]: AnalysisQuartileOption;
} => ({
	quartileTotal: {
		label: 'quad-quartile.quartile.table.filters.quartileTarget.quartileTotal',
		text: 'quad-quartile.quartile.table.filters.quartileTarget.quartileTotal',
		value: 'quartileTotal',
	},
	quartile1: {
		label: 'quad-quartile.quartile.table.filters.quartileTarget.quartile1',
		text: 'quad-quartile.quartile.table.filters.quartileTarget.quartile1',
		value: 'quartile1',
	},
	quartile2: {
		label: 'quad-quartile.quartile.table.filters.quartileTarget.quartile2',
		text: 'quad-quartile.quartile.table.filters.quartileTarget.quartile2',
		value: 'quartile2',
	},
	quartile3: {
		label: 'quad-quartile.quartile.table.filters.quartileTarget.quartile3',
		text: 'quad-quartile.quartile.table.filters.quartileTarget.quartile3',
		value: 'quartile3',
	},
	quartile4: {
		label: 'quad-quartile.quartile.table.filters.quartileTarget.quartile4',
		text: 'quad-quartile.quartile.table.filters.quartileTarget.quartile4',
		value: 'quartile4',
	},
});

export const AnalysisQuartileOptionValueMap: {
	[key in AnalysisQuartileTarget]: number | null;
} = {
	quartileTotal: null,
	quartile1: 1,
	quartile2: 2,
	quartile3: 3,
	quartile4: 4,
};
